export default "__VITE_ASSET__hNz7s$ph__"